<template>
    <div class="tl-results">
        <div class="tl-results__top">
            <z-icon
                name="minilogo"
                width="37"
                height="37"
            />
            <span v-html="title"></span>
        </div>
        <div
            v-if="isSlider"
            ref="resultSlider"
            class="tl-results__content swiper-container"
        >
            <div class="swiper-wrapper">
                <slot></slot>
            </div>
            <div class="tl-results__bottom">
                <div class="tl-results__count">
                    <span>{{ getActiveIndex }}</span>
                    <span>/{{ getSliderLength }}</span>
                </div>
                <div class="tl-results__nav">
                    <z-icon
                        class="tl-results__nav-prev"
                        name="round-arrow-folder/arrow"
                        dir="left"
                        @click="resultSlider.slidePrev()"
                    />
                    <z-icon
                        class="tl-results__nav-next"
                        name="round-arrow-folder/arrow"
                        dir="right"
                        @click="resultSlider.slideNext()"
                    />
                </div>
            </div>
        </div>
        <div v-else class="tl-results__content">
            <slot></slot>
        </div>
    </div>
</template>
<script>
import Swiper from 'swiper/dist/js/swiper.js'
export default {
    name: 'tl-results',
    props: {
        title: String,
        isSlider: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            resultSlider: null
        }
    },
    computed: {
        getActiveIndex () {
            return this.resultSlider?.activeIndex < 10 ? `0${this.resultSlider?.activeIndex + 1}` : this.resultSlider?.activeIndex + 1
        },
        getSliderLength () {
            return this.resultSlider?.slides.length < 10 ? `0${this.resultSlider?.slides.length}` : this.resultSlider?.slides.length
        }
    },
    mounted () {
        if (this.isSlider) {
            this.resultSlider = new Swiper(this.$refs.resultSlider, {
                spaceBetween: 20,
                slidesPerView: 1,
                navigation: {
                    nextEl: '.tl-results__nav-next',
                    prevEl: '.tl-results__nav-prev'
                }
            })
        }
    }
}
</script>
<style lang="scss">
.tl-results {
    @include padding-level(top, M);
    @include padding-level(right, XS);
    @include padding-level(bottom, XS);
    @include padding-level(left, M);
    max-width: 430px;
    width: 100%;
    height: 100%;
    max-height: 625px;
    display: flex;
    flex-direction: column;
    background: rgba(0, 76, 151, 0.90);
    border-radius: 0 40px 0 20px;
    overflow: hidden;

    &__top {
        @include margin-level(bottom, L);
        display: flex;
        align-items: center;
        gap: 20px;

        & .z-icon {
            margin: -3px;
            & path {
                fill: #fff;
            }
        }

        & span {
            font-family: 'Proxima Nova Condensed';
            font-size: 32px;
            font-style: normal;
            font-weight: 400;
            line-height: 100%;
            letter-spacing: -0.96px;
            color: #fff;
        }
    }

    &__content {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;

        & .z-key-indicator__name {
            color: $token-colors-gray-10;
        }

        & .swiper-slide {
            @include breakpoint(v-tablet) {
                align-items: flex-start;
                gap: 0;
            }

            & > *:not(:last-child) {
                margin-bottom: $token-spacers-2-s;
            }
        }
    }

    &__bottom {
        margin-top: auto;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 24px;
    }

    &__count {
        font-family: $robotoMono;
        font-size: 20px;
        font-weight: 300;
        line-height: 160%;
        color: #fff;
        letter-spacing: 0.2px;

        & span:last-of-type {
            font-size: 16px;
            letter-spacing: 0.16px;
        }
    }

    &__nav {
        & .z-icon {
            padding: 10px;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.90);
            cursor: pointer;
            transition: all 0.3s ease-in-out;

            &:not(:last-of-type) {
                margin-right: 8px;
            }

            & path {
                fill: $token-colors-blue;
            }

            &.swiper-button-disabled {
                background: rgba(255, 255, 255, 0.40);
                pointer-events: none;

                & path {
                    fill: #fff;
                }
            }
        }
    }
}
</style>
